import {Route, Redirect, React, lockr, RouteProps, withRouter, uiConstants, SentryRoute} from '@api'
import {authStore} from '@utils'
import {observer} from 'mobx-react'
import { Authorization } from './'
import {globalStores, nav} from '@stores'

interface MyProps extends RouteProps {
  path: string | Array<string>
}

@(withRouter as any)
@observer
export class PrivateRoute extends React.Component <Partial<MyProps>> {
  render() {
    const {props: {component: Component, ...rest}} = this, {nav: {deploymentQueryParam}, authStore: {checkIsAuthenticated}} = globalStores,
      isAuth = checkIsAuthenticated()

    // We can't actually change state here as we're in react-router's render loop
    if (!isAuth) {
      console.info(`User is not authenticated, rerouting to login`)
      nav.routeToLogoutPage()
      if (DEBUG) {
        console.debug(`If this is happening unexpectedly verify you don't have other web browser windows open to different deployments`)
      }
    }

    return (
      <SentryRoute {...rest} render={(props) => {
        return (
          isAuth
          ? <Authorization {...rest} {...props} component={Component}/>
          : <Redirect to={{
            pathname: `/login`,
            search: deploymentQueryParam,
            state:    {from: props.location}
          }}/>
        )
      }}/>
    )
  }
}





// WEBPACK FOOTER //
// ./src/modules/common/components/PrivateRoute.tsx